import types from './types'

const appActions = {
  // designed for auth reset
  resetStore: () => ({ type: types.RESET }),
}

export default appActions
